// extracted by mini-css-extract-plugin
var _1 = "#4c4c4c";
var _2 = "desktopinputs_boxdash__gwvq+";
var _3 = "desktopinputs_boxpath__snoax";
var _4 = "desktopinputs_buttonswrapper__oe9kj";
var _5 = "desktopinputs_cancel__bpoep";
var _6 = "desktopinputs_content__d-vj-";
var _7 = "desktopinputs_contentwrapper__atizm";
var _8 = "640px";
var _9 = "790px";
var _a = "#057676";
var _b = "desktopinputs_disableanimation__fxmo1";
var _c = "desktopinputs_disabled__pbihb";
var _d = "desktopinputs_forceshow__d4szn";
var _e = "#434343";
var _f = "desktopinputs_hidden__oov-o";
var _10 = "desktopinputs_inputs__ajbjf";
var _11 = "79px";
var _12 = "110px";
var _13 = "72px";
var _14 = "665px";
var _15 = "desktopinputs_outline__gd9bb";
var _16 = "desktopinputs_refresh__+8jim";
var _17 = "teal";
var _18 = "2";
var _19 = "#cdd3dc";
var _1a = "desktopinputs_validation__2ibhv";
export { _1 as "body", _2 as "boxDash", _3 as "boxPath", _4 as "buttonsWrapper", _5 as "cancel", _6 as "content", _7 as "contentWrapper", _8 as "controlsMobileWidth", _9 as "controlsStackedWidth", _a as "darkTeal", _b as "disableAnimation", _c as "disabled", _d as "forceShow", _e as "headline", _f as "hidden", _10 as "inputs", _11 as "menuHeight", _12 as "menuHeightLarge", _13 as "menuHeightMobile", _14 as "modalMobileWidth", _15 as "outline", _16 as "refresh", _17 as "teal", _18 as "timelineStrokeWidth", _19 as "timelineTrackColor", _1a as "validation" }
